import { render, staticRenderFns } from "./GlyphSetPreview.vue?vue&type=template&id=008b32a4&scoped=true&"
import script from "./GlyphSetPreview.vue?vue&type=script&lang=js&"
export * from "./GlyphSetPreview.vue?vue&type=script&lang=js&"
import style0 from "./GlyphSetPreview.vue?vue&type=style&index=0&id=008b32a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b32a4",
  null
  
)

export default component.exports